import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles`, params);
    return data;
  },

  getMinResponse: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/browse-profiles`, params);
    return data;
  },

  getById: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}`, params);
    return data;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/profiles/${id}`, body);
    return data;
  },

  getProjects: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/projects`, params);
    return data;
  },

  getDocuments: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/documents`, params);
    return data;
  },

  getTemplateForms: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/template-forms`, params);
    return data;
  },

  getTemplateFormsUsingProjectId: async (profileId, projectId, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${profileId}/projects/${projectId}/template-forms`,
      params
    );
    return data;
  },

  getFavoriteTemplates: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/template-forms/favorites`,
      params
    );

    return data;
  },

  getDocumentsToRevise: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/documents-to-revise`,
      params
    );
    return data;
  },

  getDocumentsToReviseMinResponse: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/documents-to-revise-minimized`,
      params
    );
    return data;
  },

  kindValues: async payload => {
    const { profileId, ...theRest } = payload;
    const params = { params: theRest };
    const { data } = await axios.get(
      `/profiles/${profileId}/documents-to-revise/kind/values`,
      params
    );
    return data;
  },

  getDocumentRevisionCount: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/count-documents-to-revise`,
      params
    );
    return data;
  },

  getProjectGroups: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/project-groups`, params);
    return data;
  },

  getProjectsAssociatedWithTemplate: async (id, templateFormId) => {
    const { data } = await axios.get(
      `/profiles/${id}/template-forms/${templateFormId}/projects`
    );
    return data;
  },

  getLinkedItineraries: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/itineraries/linked`,
      params
    );
    return data;
  },

  //Depracated
  // getItineraries: async (id, query) => {
  //   const params = { params: query };
  //   const { data } = await axios.get(
  //     `/profiles/${id}/itineraries/creator`,
  //     params
  //   );
  //   return data;
  // },

  getItineraries: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/itineraries`, params);
    return data;
  },

  getBookmarkedItineraries: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/itineraries/bookmarks`,
      params
    );
    return data;
  },

  canImpersonate: async id => {
    const { data } = await axios.get(`/profiles/${id}/can-impersonate`);
    return data;
  },

  getImpersonation: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/${id}/impersonated`, params);
    return data;
  },

  updateEnrollmentStep: async (id, projectGroupId, step) => {
    const { data } = await axios.post(
      `/profiles/${id}/enrollment/${projectGroupId}?step=${step}`
    );
    return data;
  },

  deleteMemberSteps: async (profileId, projectGroupId) => {
    const { data } = await axios.delete(
      `/profiles/${profileId}/enrollment/${projectGroupId}`
    );
    return data;
  },

  getProjectCount: async profileId => {
    const { data } = await axios.get(`/profiles/${profileId}/project-count`);
    return data;
  },

  getDocumentCount: async profileId => {
    const { data } = await axios.get(`/profiles/${profileId}/document-count`);
    return data;
  },

  reportAbuse: async body => {
    const { data } = await axios.post(`/profiles/report-abuse`, body);
    return data;
  },

  changeNotificationsStatus: async (id, query) => {
    const params = { params: query };
    const res = await axios.put(`/profiles/${id}/notifications`, null, params);

    return res;
  },

  getMembersMyProjects: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/my-projects-members`,
      params
    );
    return data;
  },

  getMemberProjectRoles: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/my-projects-roles`,
      params
    );
    return data;
  },

  getMemberSubscriptionStatus: async id => {
    const { data } = await axios.get(`/profiles/${id}/subscription-status`);
    return data;
  },

  profileSubscriptionCheckout: async (id, body) => {
    const { data } = await axios.post(`/profiles/${id}/checkout`, body);
    return data;
  },

  updateArchivedDocuments: async (id, archived, body) => {
    const { data } = await axios.put(
      `/profiles/${id}/documents/update-archived?archived=${archived}`,
      body
    );
    return data;
  },

  updateArchivedItineraries: async (id, archived, body) => {
    const { data } = await axios.put(
      `/profiles/${id}/itineraries/update-archived?archived=${archived}`,
      body
    );
    return data;
  },

  updateArvhiedProjects: async (id, archived, body) => {
    const { data } = await axios.put(
      `/profiles/${id}/projects/update-archived?archived=${archived}`,
      body
    );
    return data;
  },

  projectValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/profiles/projects/values`, params);
    return data;
  },

  revisionsProjectValues: async payload => {
    const { profileId, ...theRest } = payload;
    const params = { params: theRest };
    const { data } = await axios.get(
      `/profiles/${profileId}/documents-to-revise/projects/values`,
      params
    );
    return data;
  },

  getItineraryStatusCount: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/count-itineraries`,
      params
    );
    return data;
  },

  getMyProjectsDocuments: async (id, language, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/my-projects-documents?language=${language}`,
      params
    );
    return data;
  },

  //This is used for my projects creativities page
  getDocumentStatusCountCreativitiesProjects: async (id, language, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/count-my-projects-documents?language=${language}`,
      params
    );
    return data;
  },

  getDocumentStatusCount: async (id, language, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/${id}/count-documents-status?language=${language}`,
      params
    );
    return data;
  }
};
